export var NULL_REPR = {
  __superstoreNull: true
};
export var NAMESPACE_PREFIX = 'hs.superstore';
export var NAMESPACE_SUFFIX = 'default';